import React from 'react';
import { Box, makeStyles, TableRow, TableCell } from '@material-ui/core';
import BodyText from './BodyText';
import { useHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { toggleFlightDetailModal } from '../../reducers/UiReducer';
const useStyles = makeStyles(() => ({
	optionsIcon: {
		height: 25,
		width: 25,
		backgroundColor: '#FDE8EE',
		padding: 3,
		borderRadius: '50%',
	},
	tableCell: {
		fontSize: 14,
		// padding: 3,
		color: 'rgb(0 0 0 / 73%)',
		fontWeight: 600,
	},
	img: {
		'& .MuiAvatar-img': {
			width: 30,
			height: 30,
		},
	},
}));
const FlightSegment = ({ item, rowIndex }) => {
	const classes = useStyles();

	return (
		<>
			<TableRow key={rowIndex} style={{ marginTop: 20 }}>
				<TableCell className={classes.tableCell}>Indigo</TableCell>
				<TableCell className={classes.tableCell}>6E-6242</TableCell>
				<TableCell className={classes.tableCell}>Hyderabad,HYD-India</TableCell>
				<TableCell className={classes.tableCell}>Ranchi,IXR-India</TableCell>
				<TableCell className={classes.tableCell}>
					11 Oct 2020 05:40:00 AM
				</TableCell>
				<TableCell className={classes.tableCell}>
					11 Oct 2020 07:40:00 AM
				</TableCell>
			</TableRow>
		</>
	);
};

export default FlightSegment;
